import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";

const InterModal = () => {
  return (
    <>
      <Helmet>
        <title>Intermodal | Trans World Shipping</title>
        <meta
          name="description"
          content="Discover our intermodal transportation solutions for seamless cargo movement across multiple modes of transport."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/intermodal"
        />
      </Helmet>

      <TheInterModal>
        <div className="intermodal-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Intermodal</h1>
            <p>
              Cost-effective and efficient transportation across long distances
            </p>
          </div>
        </div>

        <div className="intermodal-container">
          <div className="content-section">
            <p>
              Intermodal services provide a cost-effective and efficient way to
              transport goods across long distances. Our intermodal solutions
              combine the reliability of rail with the flexibility of road
              transport, ensuring your cargo reaches its destination on time and
              in good condition.
            </p>
          </div>
        </div>
      </TheInterModal>
    </>
  );
};

const TheInterModal = styled.div`
  width: 100%;
  background: #ffffff;

  .intermodal-hero {
    position: relative;
    width: 100%;
    height: 40vh;
    min-height: 300px;
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(
        circle at 30% 50%,
        rgba(212, 175, 55, 0.1) 0%,
        transparent 70%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .intermodal-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .content-section {
    background: #f8f9fa;
    padding: 3rem;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1.2rem;
      color: #4a5568;
      line-height: 1.8;
      max-width: 900px;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 900px) {
    .intermodal-hero .hero-content h1 {
      font-size: 2.5rem;
    }

    .intermodal-container {
      padding: 3rem 1.5rem;
    }

    .content-section {
      padding: 2rem;

      p {
        font-size: 1.1rem;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .intermodal-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .intermodal-container {
      padding: 2rem 1rem;
    }

    .content-section {
      padding: 1.5rem;

      p {
        font-size: 1rem;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .intermodal-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .content-section p {
      font-size: 0.95rem;
    }
  }

  @media screen and (max-width: 480px) {
    .intermodal-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .intermodal-hero .hero-content p {
      font-size: 0.9rem;
    }

    .content-section p {
      font-size: 0.9rem;
    }
  }
`;

export default InterModal;
